<template>
  <section style="background: #eee">
    <div ref="tesHtml" style="width: fit-content; margin: 16px auto;">
      <vue-html2pdf
        v-if="!loading"
        :enable-download="true"
        :preview-modal="false"
        :show-layout="true"
        :pdf-quality="2"
        :filename="`${data.member?.fullname} - Certificate of Achievement`"
        pdf-orientation="landscape"
        :manual-pagination="true"
        pdf-content-width="1122px"
        :paginate-elements-by-height="793"
        pdf-format="a4"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section
            :style="{
              position: 'relative',
            }"
          >
            <img :src="BG_CERTIFICATE" :style="{ width: '1122px' }" />
            <!-- User data -->
            <div
              :style="{
                position: 'absolute',
                top: '235px',
                left: '530px',
                fontSize: '15px',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontFamily: 'Arial, sans-serif',
              }"
            >
              {{ data.order_no }}
            </div>
            <!-- User data -->
            <div
              style="
                position: absolute;
                top: 296px;
                left: 295px;
                font-size: 15px;
                line-height: 1.6;
                font-weight: 600;
                font-family: 'Arial, sans-serif', sans-serif;
              "
            >
              <div>{{ data.member?.fullname }}</div>
              <div>{{ data.member?.meta?.nim }}</div>
              <div>{{ date_format(data.start_test) }}</div>
            </div>
            <!-- Score data -->
            <div
              style="
                position: absolute;
                top: 418px;
                left: 685px;
                font-size: 14px;
                line-height: 1.6;
                font-weight: 600;
                font-family: 'Arial, sans-serif', sans-serif;
              "
            >
              <div>
                {{ data.section ? data.section.reading.total_point : "" }}
              </div>
              <div>
                {{ data.section ? data.section.structure.total_point : "" }}
              </div>
              <div>
                {{ data.section ? data.section.listening.total_point : "" }}
              </div>
              <div>{{ correct }}</div>
              <div>{{ data.score }}</div>
            </div>
            <div
              style="
                position: absolute;
                top: 533px;
                left: 535px;
                font-size: 22px;
                font-weight: 900;
                font-family: 'Arial, sans-serif', sans-serif;
              "
            >
              {{ data.level }}
            </div>
            <div
              style="
                position: absolute;
                top: 600px;
                left: 230px;
                font-size: 18px;
                font-weight: 900;
                font-family: 'Arial, sans-serif', sans-serif;
              "
            >
              {{ expired }}
            </div>
            <div style="position: absolute; top: 560px; left: 115px">
              <vue-qrcode
                :value="`https://admin-eptpnk.epot.co.id/public/certificate/${$route.params.license}`"
                errorCorrectionLevel="H"
                :width="110"
                :margin="0"
                :color="{ dark: '#000' }"
              />
            </div>
          </section>
        </section>
        <section slot="pdf-content">
          <section>
            <img :src="BG_CERTIFICATE_BACK" :style="{ width: '1122px', height: '785px' }" />
          </section>
        </section>
      </vue-html2pdf>
    </div>
  </section>
</template>

<script>
import BG_CERTIFICATE from "@/assets/images/new_certificate_front.png";
import BG_CERTIFICATE_BACK from "@/assets/images/new_certificate_back.png";
import VueHtml2pdf from "vue-html2pdf";
import VueQrcode from "vue-qrcode";

export default {
  components: {
    VueQrcode,
    VueHtml2pdf,
  },
  data: () => ({
    loading: true,
    data: {},
  }),
  computed: {
    BG_CERTIFICATE: () => BG_CERTIFICATE,
    BG_CERTIFICATE_BACK: () => BG_CERTIFICATE_BACK,
    correct() {
      let section = this.data.section;
      return section
        ? `${
            section.listening.total_point +
            section.reading.total_point +
            section.structure.total_point
          }`
        : "";
    },
    expired() {
      let expired = new Date(this.data.end_test);
      expired.setFullYear(expired.getFullYear() + 2);
      return this.date_format(expired);
    },
  },

  mounted() {
    this.getData();
  },
  methods: {
    date_format(raw_date) {
      let date = new Date(raw_date);

      return Date.parse(raw_date)
        ? `${date.toLocaleString("default", {
            month: "long",
          })} ${date.getDate()}, ${date.getFullYear()}`
        : "";
    },
    async getData() {
      this.loading = true;
      const ACCESS_KEY = process.env.VUE_APP_ACCESS_KEY;
      const { data: res } = await this.axios
        .get(`/license/v1/detail-member-order/${this.$route.params.license}`, {
          headers: {
            "access-key": ACCESS_KEY,
          },
        })
        .catch((e) => {
          this.$router.replace("/404-not-found");
          throw e;
        })
        .finally(() => {});
      this.data = res.data;
      this.loading = false;
      setTimeout(() => {
        this.generateFile();
      }, 5e2);
    },
    generateFile() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style></style>
